import { render, staticRenderFns } from "./LosLockForm.vue?vue&type=template&id=4835440e&scoped=true&"
import script from "./LosLockForm.vue?vue&type=script&lang=js&"
export * from "./LosLockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835440e",
  null
  
)

export default component.exports